<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
              <el-tab-pane label="UWB基站配置" name="first" clor="red"></el-tab-pane>
              <el-tab-pane label="UWB基站组" name="second"></el-tab-pane>
              <el-tab-pane label="UWB自动测距" name="third"></el-tab-pane>
          </el-tabs>
					
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<UwbBSTable v-show="activeName == 'first'" ref="uwbBsTable"/>
		<UwbBSGroupTable v-show="activeName == 'second'" ref="uwbBSGroupTable"/>
		<UwbBSSelfRangeTable v-show="activeName == 'third'" ref="uwbBSSelfRangeTable" />
		
    </div>
</template>

<script>
	import UwbBSTable from '@/components_pages/Device/UwbBSTable.vue'
	import UwbBSGroupTable from '@/components_pages/Device/UwbBSGroupTable.vue'
	import UwbBSSelfRangeTable from '@/components_pages/Device/UwbBSSelfRangeTable.vue'
	
	export default {
	    /*
	     * 组件名
	     */
	    name: "BsDevice",
	    /**
	     * 引用组件
	     * */
	    components: {
	      // 基站表
	      UwbBSTable,
	      UwbBSGroupTable,
	      UwbBSSelfRangeTable
	    },// components
	    data() {
	        return {
	            activeName: 'first'
	        }// return
	    },// data()
	    mounted(){
	    	
	    },// mounted
	    
	    /**
	     * @Des 方法
	     * @Auth
	     * @Date 
	     */
	    methods: {
	        /**
	         * @Des 关闭路由
	         * @Auth
	         * @Date
	         */
	        closeRouter () {
	            // 跳转到 首页
	            this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
	        },// closeRouter
	        
	        handleClick(tab, event) {
	            if (tab.index == 0) {
	                // 请求1
	            } else if (tab.index == 1) {
	                // 请求2
	            } else if (tab.index == 2) {
	            	
	            }
	        },// handleClick
	        
	    }// methods
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/device/BsDevice.vue